<!--
 * @Author: your name
 * @Date: 2021-09-23 11:35:20
 * @LastEditTime: 2024-12-21 20:06:20
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 对于超出文案的基本tip展示
 * @FilePath: /eafront-website/src/directives/components/over-tip/index.vue
-->
<template>
  <div :class="['gx-hover-tip', isScroll && 'is-scroll', classify]" :style="tipContainerStyle">
    <div class="tip-content" ref="ct" :style="contentStyle">
      <slot>{{ value }}</slot>
    </div>
    <i
      class="tip-arrow"
      v-if="arrowPosition && !noArrow"
      ref="tipArrow"
      :class="arrowPosition"
      :style="computedArrowStyle"
    ></i>
  </div>
</template>
<script lang="ts">
import { isEllipsis } from '@/utils/tools';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'VToolTip',
  props: {
    value: {
      type: [String, Number],
    },
    arrowPosition: {
      type: String,
      default: '',
    },
    arrowStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tipStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    column: {
      type: Number,
      default: 0,
    },
    classify: {
      type: String,
      default: '',
    },
    minWidth: {
      type: String,
      default: '252px',
    },
    noArrow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    contentStyle() {
      // 从 tipStyle 中移除 background 相关属性，避免覆盖容器样式
      const { background, backgroundColor, color, ...otherStyles } = this.tipStyle || {};
      const styleObj = { ...otherStyles };

      if (this.column * 1) {
        styleObj.maxHeight = this.column * 20 + 'px';
      }
      if (this.overMin) {
        styleObj.minWidth = this.getMinWidth();
      }
      return styleObj;
    },
    tipContainerStyle() {
      // 提取容器级别的样式（background, color 等）
      const { background, color, backgroundColor, padding, fontSize, borderRadius, boxShadow, maxWidth, zIndex } = this.tipStyle || {};
      const containerStyle: Record<string, any> = {};

      // 背景和颜色
      if (background) containerStyle.background = background;
      if (backgroundColor) containerStyle.backgroundColor = backgroundColor;
      if (color) containerStyle.color = color;

      // 其他容器样式
      if (padding) containerStyle.padding = padding;
      if (fontSize) containerStyle.fontSize = fontSize;
      if (borderRadius) containerStyle.borderRadius = borderRadius;
      if (boxShadow) containerStyle.boxShadow = boxShadow;
      if (maxWidth) containerStyle.maxWidth = maxWidth;
      if (zIndex !== undefined) containerStyle.zIndex = zIndex;

      return containerStyle;
    },
    computedArrowStyle() {
      // 箭头样式，继承容器的背景色
      const arrowStyle = { ...this.arrowStyle };
      const { background, backgroundColor } = this.tipStyle || {};

      // 优先使用 background，其次 backgroundColor
      if (background) {
        arrowStyle.background = background;
      } else if (backgroundColor) {
        arrowStyle.background = backgroundColor;
      }

      return arrowStyle;
    },
  },
  data() {
    return {
      isScroll: false,
      overMin: false,
    };
  },
  methods: {
    getMinWidthNum() {
      const { width, minWidth } = this.tipStyle;
      // console.log('width', width)
      return parseInt(minWidth) || parseInt(width) || parseInt(this.minWidth);
    },
    getMinWidth() {
      const { width, minWidth } = this.tipStyle;
      // console.log('width', width)
      return minWidth || width || this.minWidth;
    },
    getResetInfo({
      left,
      right,
      top,
      bottom}: Record<string, number>) {
        let x = 0;
        let y = 0;
        if (left < 0) {
          x = -left
        }
        if (!x && right < 0) {
          x = right
        }
        if (top < 0) {
          y = -top
        }
        if (!y && bottom < 0) {
          y = bottom
        } 
      return {
        x,
        y
      }
    },
    resetPositions() {
      const rectInfo = this.$el.getBoundingClientRect()
      const positionInfo = {
        left: rectInfo.left,
        top: rectInfo.top,
        right: window.innerWidth - rectInfo.right,
        bottom: window.innerHeight - rectInfo.bottom
      }
      const currentStyles = window.getComputedStyle(this.$el)
      const resetInfo = this.getResetInfo(positionInfo)
      if(resetInfo.x !== 0) {
        const currentLeft = parseFloat(currentStyles.left) || 0;
        const resetLeft = currentLeft + resetInfo.x;
        (this.$el as HTMLElement).style.left = resetLeft + 'px'
      }

      if(resetInfo.y !== 0) {
        const currentTop = parseFloat(currentStyles.top) || 0;
        const resetTop = currentTop + resetInfo.y;
        (this.$el as HTMLElement).style.top = resetTop + 'px'
      }
    }
  },
  mounted(this: any) {
    this.$nextTick(() => {
      if (this.$refs.ct.scrollHeight > this.$refs.ct.clientHeight) {
        this.isScroll = true;
      }
      const minNum = this.getMinWidthNum();
      const isOver = isEllipsis(this.$refs.ct, minNum);
      const isToLess = this.$refs.ct.offsetWidth < minNum;
      if (isToLess && isOver) {
        this.overMin = true;
      }
      // 含换行符的内容需保留 pre-line 换行，不再强制 nowrap（否则 \n 会被折叠成空格挤成一行）
      const hasLineBreak = typeof this.value === 'string' && this.value.includes('\n');
      if (!isOver && isToLess && !hasLineBreak) {
        this.$refs.ct.style.whiteSpace = 'nowrap';
      }
      this.$nextTick(()=>{
        this.resetPositions();
      })
    });
  },
});
</script>
<style lang="scss" scoped>
.gx-hover-tip {
  position: absolute;
  box-sizing: border-box;
  max-width: 268px;
  width: fit-content;
  padding: 6px 8px;
  z-index: 9999;
  word-break: break-all;
  font-size: 13px;
  line-height: 20px;
  border-radius: 6px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7); /* 默认背景色，可被 style 覆盖 */
  cursor: default;
  /* pointer-events: none; */
}
.is-scroll {
  padding-right: 4px;
}
.tip-content {
  overflow: auto;
  text-align: initial;
  white-space: pre-line;
  // word-break: break-all;
  &.ea-scrollbar {
    &::-webkit-scrollbar-track {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}
.tip-arrow {
  position: absolute;
  display: block;
  height: 8px;
  width: 8px;
  transform: rotateZ(45deg);
  // background: rgba(0, 0, 0, 0.7); /* 默认背景色，会被计算属性覆盖 */
  z-index: -1;
}
.top {
  left: 50%;
  bottom: -3px;
  margin-left: -4px;
}
.bottom {
  left: 50%;
  top: -3px;
  margin-left: -4px;
}
.left {
  right: -3px;
  top: 50%;
  margin-top: -3px;
}
.right {
  left: -3px;
  top: 50%;
  margin-top: -3px;
}
</style>
